import store from "@/state/store";
import { landingPath } from "@/libs/landing";

export default [
  {
    // general landing page; needs a login but no permission
    path: "/home",
    name: "home",
    meta: {
      title: "Home",
      authRequired: true,
      breadcrumb: () => [
        { text: 't-home', to: null }
      ]
    },
    component: () => import("@/views/home/index.vue"),
  },
  {
    // old template dashboard URL: send people to wherever they now start
    path: "/dashboard",
    redirect: "/",
  },
  {
    // start page: PAS dashboard for PAS users who may view it, home page for everyone else
    path: '/',
    redirect: () => {
      const isAuthenticated = store.getters['auth/loggedIn']; // Check if user is logged in
      return isAuthenticated ? landingPath() : '/login';
    },
  }
];
